import { FilterContentItem } from '@/corePagesModule/filterModal/filterModal';
import { i18n } from '@/i18n';

/**
 * 発注グループのサービス
 */
export class OrderGroupService {
  /**
   * 発注グループのフィルター項目を生成する
   * @param targetOrderGroupId - 対象の発注グループID
   */
  static getFilterContentItem = (targetOrderGroupId: string): FilterContentItem => {
    const t = i18n.t;
    return {
      filterType: 'ORDER_GROUP_ID',
      selectedValue: [targetOrderGroupId],
      label: t('発注グループ'),
    };
  };
}
